import React, { createContext, useState } from "react";
import useEnv, { LogLevel } from "../hooks/env";
import UserInfoApi, { UserInfo } from "../api/services/UserInfoApi";
import { HttpErrorType } from "../models/HttpErrorType";

export interface UserContextType {
  error: HttpErrorType;
  getUser: () => Promise<void>;
  user: UserInfo | null;
}

export const UserContext = createContext<UserContextType>({
  error: {},
  getUser: () => Promise.reject(),
  user: null,
});

export const UserContextProvider: React.FunctionComponent = (props) => {
  const { api } = useEnv();
  const userInfoApi = new UserInfoApi(api);
  const [error, setError] = useState({});
  const [user, setUser] = useState<UserInfo | null>(null);
  const { log } = useEnv();

  const getUser = (): Promise<void> => {
    return userInfoApi
      .getUserInfo()
      .then((userResponse) => setUser(userResponse.data))
      .catch((e) => {
        log(LogLevel.ERROR, "Error getting user info", e);
        setError({ message: "Error getting user info", response: e });
      });
  };

  const { children } = props;

  return (
    <UserContext.Provider
      value={{
        error,
        getUser,
        user,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
